/*
 * @Author: your name
 * @Date: 2021-07-17 10:11:33
 * @LastEditTime: 2021-07-29 11:31:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \portal\src\api\famous_teacher.js
 */
import Request from "./index"
import qs from "qs";

class Api {
  // 获取名师列表分页列表
  static getFamousTeacherList(data) {
    return Request.get(`/famous_teacher`, { params: data });
  }

  //获取名师详情
  static getFamousTeacherDetail(id) {
    return Request.get(`/famous_teacher/get_teacher`, {
      params: {
        user_id: id
      }
    });
  }

  //删除名师
  static deleteFamousTeacher(ids) {
    return Request.delete(`/famous_teacher/remove_famous_teacher`, {
      params: {
        user_id: ids
      }
    });
  }

  //保存教师信息
  static saveTeacherInfo(data) {
    return Request.put(`/famous_teacher/set_teacher`, data);
  }

  //添加名师
  static addFamousTeacher(data) {
    return Request.post(`/famous_teacher/add_famous_teacher`, qs.stringify(data), { headers: { "Content-Type": "application/x-www-form-urlencoded" } });
  }

  //获取名师资源分页列表
  static getFamousTeacherResourceList(data) {
    return Request.get(`/famous_teacher/resource_page`, {
      params: data
    });
  }

}

export default Api